// @ts-check
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';

import { Subscription } from 'rxjs/Subscription';

import 'rxjs/add/operator/debounceTime';
import 'rxjs/add/operator/map';

import { Guest } from '@models/guest-ao';
import { ContentService } from '@services/content.service';
import { GuestService } from '@services/guest.service';

import { slideInOutTrigger } from '../../animations/elementAnimations';
import { LanguageService } from '@app/services/language.service';

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss'],
  animations: [slideInOutTrigger],
})
export class FormComponent implements OnInit, OnDestroy {
  saveState: 'SAVED' | 'DIRTY' | 'ERROR' = 'SAVED';
  uid: string;
  step: number;
  guestForm: FormGroup;

  guestData: Guest;

  private guest: Guest;
  private subStepParam: Subscription;
  private subGuest: Subscription;
  private subSaving: Subscription;
  private lastStep = 4;

  constructor(
    public gs: GuestService,
    private formBuilder: FormBuilder,
    public cs: ContentService,
  ) {
    this.gs.guest$.subscribe(
      guest => (this.guestData = $.extend(true, {}, guest)),
    );
  }

  private filterObject(obj: {}, filter: {}) {
    return Object.keys(filter).reduce((agg, key) => {
      agg[key] = obj[key];
      return agg == null ? 'n/a' : agg;
    }, {});
  }

  private initializeGuest() {
    this.subGuest = this.gs.guest$
      .filter(guest => guest != null)
      .do(guest => {
        this.uid = guest.id;
        if (guest.rsvp) {
          const filteredGuest = this.filterObject(
            guest.rsvp,
            this.guestForm.controls,
          );
          this.guestForm.setValue(filteredGuest, { emitEvent: false });
        }
      })
      .subscribe();
  }

  private initializeSaving() {
    this.subSaving = this.guestForm.valueChanges
      // .map(form => ({
      //   ...form,
      //   ...[
      //     'adults_day1',
      //     'adults_day2',
      //     'kids_day1',
      //     'kids_day2',
      //     'babies_day1',
      //     'babies_day2',
      //   ].reduce(
      //     (acc, key) => ({ ...acc, [key]: Math.max(0, form[key] - 1) }),
      //     {},
      //   ),
      // }))
      .map(rsvp => ({ rsvp }))
      .do(rsvp => {
        this.saveState = 'DIRTY';
        this.guest = { ...this.guest, ...rsvp };
      })
      .debounceTime(1000)
      .do(guest => this.onFormChange(guest))
      .subscribe();
  }

  ngOnInit() {
    const fb = this.formBuilder;
    this.guestForm = fb.group({
      day_1: [false],
      day_2: [false],
      breakfast: [false],
      adults_day1: [1],
      adults_day2: [1],
      kids_day1: [1],
      kids_day2: [1],
      babies_day1: [1],
      babies_day2: [1],
      comments: [''],
    });

    this.initializeGuest();
    this.initializeSaving();
  }

  ngOnDestroy() {
    if (this.subStepParam) {
      this.subStepParam.unsubscribe();
    }
    if (this.subGuest) {
      this.subGuest.unsubscribe();
    }
    if (this.subSaving) {
      this.subSaving.unsubscribe();
    }
  }

  get day1(): boolean {
    return !!this.guestForm.get(`day_1`).value;
  }
  get day2(): boolean {
    return !!this.guestForm.get(`day_2`).value;
  }
  accTotal(day: number): number {
    return this.accAdults(day) + this.accKids(day) + this.accBabies(day);
  }
  accAdults(day: number): number {
    const control = this.guestForm.get(`adults_day${day}`);
    return !control ? 0 : (control.value as number);
  }
  accKids(day: number): number {
    const control = this.guestForm.get(`kids_day${day}`);
    return !control ? 0 : (control.value as number);
  }
  accBabies(day: number): number {
    const control = this.guestForm.get(`babies_day${day}`);
    return !control ? 0 : (control.value as number);
  }

  forceSave() {
    this.onFormChange(this.guest);
  }

  onFormChange(guest: any) {
    // console.log('form:', guest);
    this.gs
      .updateGuest(this.uid, guest)
      .then(o => (this.saveState = 'SAVED'), e => (this.saveState = 'ERROR'));
  }
}



// WEBPACK FOOTER //
// ./src/app/components/form/form.component.ts